import React from "react";
import { Input, Icon, Dropdown, DropdownOption, Button, NumericInput } from "@abb/abb-common-ux-react";
import IDirectionData from "../../models/direction/directionData";
import { IKeyedInProperty } from "../../models/testplan/TestplanKeyedIn";
import { IKeyedInPartition } from "../../models/testplan/KeyedInPartition";
import { IKeyedInDirection, KeyedInDirection } from "../../models/testplan/IKeyedInDirection";
import { ABB_CHECK_MARK, ABB_CLOSE, ABB_TRASH, ABB_PLUS } from "../../utilities/IconConstants";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";

interface IProps {
    keyedInProperty: IKeyedInProperty;
    partition: IKeyedInPartition;
    directions: IDirectionData[];
    onDelete: (keyedInProperty: IKeyedInProperty, partition: IKeyedInPartition) => void;
    onSave: (keyedInProperty: IKeyedInProperty, partition: IKeyedInPartition, partitionNameError: boolean) => void;
    onCancel: (keyedInProperty: IKeyedInProperty, partition: IKeyedInPartition) => void;
    countValidate: (value: string | number, direction: any, partition: any, index: number) => void;
}

interface IState {
    partition: IKeyedInPartition;
    directionAvailableCount: number;
    directionsAvailableList: IDirectionData[];
    partitionNameError: boolean;
}

export default class KeyedInEditablePartition extends React.Component<IProps, IState> {
    private _previousState: string;

    constructor(props: IProps) {
        super(props);

        this.state = {
            partition: this.props.partition,
            directionAvailableCount: this.props.directions.length - 1,
            directionsAvailableList: this.props.directions,
            partitionNameError: false
        };

        this._previousState = JSON.stringify(this.props.partition);
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className="stepwizard-step">
                            <a href="#step-1" className="position-bar" />
                            <div className="position-header position-edit-color px-3" style={{width: "180px"}}>
                                <Input dataType="text"
                                    type="normal"
                                    disabled={false}
                                    className="mt-2 input-text-center text-ellipsis page-layout"
                                    value={String(this.state.partition.name)}
                                    onValueChange={this.setName}
                                />
                            </div>
                            <div className="position-content position-edit-content-color dropdown-position" style={{width: "180px"}}>
                                {this.state.partition.directions.map((direction: IKeyedInDirection, index: number) =>
                                    <React.Fragment key={index}>
                                        <div className="px-3">
                                            <span className="position-font">{t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}: </span>
                                            <Dropdown
                                                className="dropdown-appear"
                                                label={t(CONSTANTS.LABEL_SELECT) + " " + t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}
                                                required={true}
                                                placeholder={t(CONSTANTS.LABEL_PICK) + " " + t(CONSTANTS.LABLE_INSTRUMENT_DIRECTIONS)}
                                                value={direction.dropdown}
                                                onChange={(value) => this.setDirection(value, index)}
                                            >
                                                {this.state.directionsAvailableList.map((item, innerIndex) =>
                                                    <DropdownOption key={innerIndex}
                                                        value={item.id} label={item.name} />
                                                )}
                                            </Dropdown>
                                        </div>
                                        <hr className="hr-line position-content-line position-edit-color mt-2" />
                                        <div className="mb-2">
                                            <div className="form-group row margin-align" style={{padding:0, margin:0}}>
                                                <label className="position-font mt-3" style={{width: "27%", margin: "0 10px"}}>{t(CONSTANTS.LABEL_COUNT)}:</label>
                                                <div className="mt-2" style={{width: "60%"}}>
                                                    <NumericInput
                                                        type="normal"
                                                        disabled={false}
                                                        disableEdit={false}
                                                        className="disable-input position-font input-text-left w-25"
                                                        value={direction.count}
                                                        min={1}
                                                        max={99}
                                                        step={1}
                                                        onChange={(value: number) => this.setDirectionCount(value, index)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}

                                <hr className="hr-line position-content-line position-edit-color mt-2" />
                                <div className=" row position-button mt-1 ml-1 p-1">
                                    <span className="position-button-color cursor" onClick={() => this.props.onSave(this.props.keyedInProperty, this.state.partition, this.state.partitionNameError)}>
                                        <Icon name={ABB_CHECK_MARK} color="#3366ff" />
                                        {t(CONSTANTS.BUTTON_SAVE)}
                                    </span>
                                    <span className="position-button-color cursor" onClick={() => this.props.onCancel(this.props.keyedInProperty, JSON.parse(this._previousState))}>
                                        <Icon name={ABB_CLOSE} color="#3366ff" />
                                        {t(CONSTANTS.BUTTON_CANCEL)}
                                    </span>
                                    <span className="cursor" onClick={() => this.props.onDelete(this.props.keyedInProperty, this.state.partition)}>
                                        <Icon name={ABB_TRASH} color="red" />
                                    </span>
                                </div>
                            </div>

                        </div >
                }
            </Translation>
        );
    }

    onAddDirectionsClick = () => {
        const directionsAvailable = this.props.directions;
        if (directionsAvailable.length > 0) {
            const directions = this.state.partition.directions;
            directions.push(new KeyedInDirection(directionsAvailable[0].id, directionsAvailable[0].name, 1));
            this.setState({
                partition: {
                    ...this.state.partition,
                    directions
                },
                directionAvailableCount: directionsAvailable.length - 1,
                directionsAvailableList: directionsAvailable
            });
        }
    }

    setName = (value: string) => {
        var rgFile = CONSTANTS.COMMONREGEXP;
        if (value.trim() && !rgFile.test(value)) {
            const partition = this.state.partition;
            partition.name = value;
            this.setState({
                partition,
                partitionNameError: false
            });
        } else {
            const partition = this.state.partition;
            partition.name = value;
            this.setState({
                partition,
                partitionNameError: true
            });
        }
    }
    

    setDirection(value: any, index: number) {
        const directions = [...this.state.partition.directions];
        directions[index] = new KeyedInDirection(value[0].value, value[0].label, directions[index].count);
        this.setState({
            partition: {
                ...this.state.partition,
                directions
            }
        });
    }

    setDirectionCount(value: string | number, index: number): void {
        if(value === undefined) value="1";
        let directions = [...this.state.partition.directions];
        let direction = { ...directions[index] }
        direction = new KeyedInDirection(directions[index].id, directions[index].name, Number(value));

        directions[index] = direction;

        this.setState({
            partition: {
                ...this.state.partition,
                directions
            }
        }, () => {
            this.props.countValidate(value, direction, this.state.partition, index)
        });
    }
}